var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import t from 'prop-types';
import Texto from '../../texto/texto';
import * as Util from '../../util';
var CLICK_EVENT_NAME = Util.is_touch_device() ? 'onTouchEnd' : 'onClick';

var Pestana = function Pestana(_ref) {
  var boton = _ref.boton,
      onBoton = _ref.onBoton,
      _ref$clases = _ref.clases,
      clases = _ref$clases === undefined ? [] : _ref$clases;
  var clasesPestana = ['botonEnlace'].concat(clases);
  var eventHandlers = {};

  if (onBoton && !boton.anulado) {
    eventHandlers[CLICK_EVENT_NAME] = function (e) {
      e.preventDefault();
      onBoton(e);
    };
  }

  if (boton.anulado) {
    clasesPestana.push('desactivado');
  }

  var _boton$id$split = boton.id.split(','),
      id = _boton$id$split[0],
      texto = _boton$id$split.slice(1);

  texto = texto.join(',');

  if (boton.multiLinea) {
    texto = texto.split(' ').join('*');
  }

  if (texto && texto.indexOf('*') !== -1) {
    clasesPestana.push('dobleLinea');
  }

  return React.createElement('div', _extends({
    id: 'botonEnlace' + id,
    className: clasesPestana.join(' ')
  }, eventHandlers), texto && React.createElement(Texto, {
    texto: texto
  }), !texto && React.createElement('span', null));
};

Pestana.propTypes = process.env.NODE_ENV !== "production" ? {
  boton: t.object,
  onBoton: t.func,
  clases: t.array
} : {};
export default Pestana;